import React, { Component } from 'react'

export default class DisplayRecordText extends Component {
    onChangeItem = (event) => {
        let value = event.target.value;
        if (value && value > 100) {
            value = 100;
        }
        if (value == 20 || value == 50 || value == 100) {
            this.props.onChangeItem(value);
        }
    }
    render() {
        return (
            <div>
                <div className="pull-right">
                    <label className="mr-sm-2 pull-left">Số bản ghi trên 1 trang</label>
                    <select className="pull-left" style={{ width: 60,marginLeft: 3 }} onChange={this.onChangeItem} value={this.props.itemsCountPerPage || 20}>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/controls/_DisplayRecordText.js